/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterConversationLabelKind =
  (typeof FilterConversationLabelKind)[keyof typeof FilterConversationLabelKind];

export const FilterConversationLabelKind = {
  conversation_label: 'conversation_label',
} as const;
